import React, { useRef } from "react";
import { toast } from "sonner";
import { FileText, X, Upload } from "lucide-react";

export const KYC_SLOTS = [
  { kind: "gst", label: "GST certificate" },
  { kind: "pan", label: "PAN card" },
];

const toB64 = (file) => new Promise((res, rej) => { const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(file); });

// Picks GST + PAN files (PDF/JPG/PNG ≤5MB) and reports [{kind, filename, data_base64}] via onChange.
export default function KycUploader({ docs, onChange, idPrefix = "kyc", compact = false }) {
  const refs = useRef({});
  const pick = async (kind, file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return toast.error("File must be under 5 MB");
    if (!/^(application\/pdf|image\/(jpeg|png))$/.test(file.type)) return toast.error("Only PDF, JPG or PNG");
    const data_base64 = await toB64(file);
    onChange([...docs.filter((d) => d.kind !== kind), { kind, filename: file.name, data_base64 }]);
  };
  const remove = (kind) => onChange(docs.filter((d) => d.kind !== kind));
  return (
    <div className={`grid ${compact ? "grid-cols-1" : "sm:grid-cols-2"} gap-3`} data-testid={`${idPrefix}-uploader`}>
      {KYC_SLOTS.map((s) => {
        const d = docs.find((x) => x.kind === s.kind);
        return (
          <div key={s.kind} className="rounded-xl border border-dashed border-stone-300 bg-white p-3 text-sm">
            <div className="text-[11px] font-bold uppercase tracking-wider text-stone-500">{s.label} <span className="text-stone-400 normal-case font-medium">(optional)</span></div>
            {d ? (
              <div className="mt-1.5 flex items-center gap-2" data-testid={`${idPrefix}-${s.kind}-picked`}>
                <FileText className="w-4 h-4 text-emerald-700 shrink-0" /><span className="truncate flex-1 font-semibold">{d.filename}</span>
                <button type="button" data-testid={`${idPrefix}-${s.kind}-remove`} onClick={() => remove(s.kind)} className="text-stone-400 hover:text-red-600"><X className="w-4 h-4" /></button>
              </div>
            ) : (
              <button type="button" data-testid={`${idPrefix}-${s.kind}-pick`} onClick={() => refs.current[s.kind]?.click()} className="mt-1.5 inline-flex items-center gap-1.5 rounded-full border border-stone-300 px-3 py-1 text-xs font-bold text-stone-700 hover:border-emerald-700 hover:text-emerald-800"><Upload className="w-3.5 h-3.5" />Choose file</button>
            )}
            <input ref={(el) => (refs.current[s.kind] = el)} data-testid={`${idPrefix}-${s.kind}-input`} type="file" accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png" className="hidden" onChange={(e) => { pick(s.kind, e.target.files?.[0]); e.target.value = ""; }} />
          </div>
        );
      })}
    </div>
  );
}
